<template>
  <ExtendedDialog
    :show-dialog="show"
    :config="config"
    :show-action-flag="showActionFlag"
    @update:action-flag="hideDialog"
    @update:show-dialog="show = $event"
    @execute-action="execute($event)"
  >
    <p class="ma-0 px-10 pb-4 p16-text" v-html="$t(infoText)" />
  </ExtendedDialog>
</template>

<script lang="ts">
import ExtendedDialog from '@/components/common/dialog/ExtendedDialog.vue';
import { Dialog } from '@/components/types/Dialog';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InfoDialog',
  components: { ExtendedDialog },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    config: {
      type: Object as () => Dialog,
      required: true
    },
    showActionFlag: {
      type: Boolean,
      default: true
    },
    infoText: {
      type: String,
      required: true
    }
  },

  emits: ['update:showDialog', 'update:actionFlag', 'executeAction'],
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.$emit('update:showDialog', value);
      }
    }
  },
  methods: {
    hideDialog(hide: boolean): void {
      this.$emit('update:actionFlag', hide);
    },
    execute(callbackID) {
      this.$emit('executeAction', callbackID);
    }
  }
});
</script>
